/**
 * @generated SignedSource<<e8d06da983156f32b4f00401db6b23e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DiagnosticsCompletedStudentsQuery$variables = {
  classIds?: ReadonlyArray<string> | null | undefined;
};
export type DiagnosticsCompletedStudentsQuery$data = {
  readonly allStudents: {
    readonly nodes: ReadonlyArray<{
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type DiagnosticsCompletedStudentsQuery = {
  response: DiagnosticsCompletedStudentsQuery$data;
  variables: DiagnosticsCompletedStudentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "classIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "classIds",
            "variableName": "classIds"
          },
          {
            "kind": "Literal",
            "name": "onlyWithOutstandingDiagnostic",
            "value": null
          },
          {
            "kind": "Literal",
            "name": "onlyWithResetDiagnostic",
            "value": true
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "StudentConnection",
    "kind": "LinkedField",
    "name": "allStudents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Student",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticsCompletedStudentsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticsCompletedStudentsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3bb55b0fd937ae48c9f7f73c409f9665",
    "id": null,
    "metadata": {},
    "name": "DiagnosticsCompletedStudentsQuery",
    "operationKind": "query",
    "text": "query DiagnosticsCompletedStudentsQuery(\n  $classIds: [ID!]\n) {\n  allStudents(filter: {classIds: $classIds, onlyWithResetDiagnostic: true}, first: 100) {\n    nodes {\n      id\n      firstName\n      lastName\n      publicUserId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6869d55582d925e136ff77f6c5e42753";

export default node;
